import { ModuleIntro, ModuleBanner } from "@/components/ModuleIntro";
import React from "react";

const PrimaryBtn = ({ children, onClick, testid }) => (
  <button
    onClick={onClick}
    data-testid={testid}
    className="px-8 py-3.5 rounded-full bg-[var(--gold)] text-white font-medium shadow-sm hover:brightness-105 active:scale-[0.99] transition-all"
  >
    {children}
  </button>
);

const GhostBtn = ({ children, onClick, testid }) => (
  <button
    onClick={onClick}
    data-testid={testid}
    className="px-6 py-3 rounded-full border border-[var(--gold)] text-[var(--gold)] font-medium hover:bg-[var(--gold)] hover:text-white transition-colors"
  >
    {children}
  </button>
);

export const Welcome = ({ t, onStart, lang = "fr", moduleKey = "besoins" }) => (
  <div className="animate-fade-up text-center">
    <ModuleBanner moduleKey={moduleKey} />
    <h1 className="font-serif-title text-4xl sm:text-5xl lg:text-6xl text-[var(--gold)] leading-tight mb-6">
      {t.welcomeTitle}
    </h1>
    <p className="text-[var(--ink)] leading-relaxed max-w-xl mx-auto mb-8">{t.welcomeText}</p>
    <ModuleIntro moduleKey={moduleKey} lang={lang} className="mb-8" />
    <PrimaryBtn onClick={onStart} testid="btn-start">{t.start}</PrimaryBtn>
  </div>
);

export const Presentation = ({ t, onPrev, onNext }) => (
  <div className="animate-fade-up">
    <h2 className="font-serif-title text-3xl sm:text-4xl text-[var(--gold)] mb-6 text-center">{t.presTitle}</h2>
    <div className="rounded-3xl bg-[var(--sand)] border border-[var(--border)] p-6 sm:p-8 space-y-4 text-[var(--ink)] leading-relaxed">
      <p>{t.pres1}</p>
      <p>{t.pres2}</p>
      <p><strong>{t.pres3}</strong></p>
    </div>
    <div className="flex items-center justify-between mt-8">
      <GhostBtn onClick={onPrev} testid="btn-prev">{t.prev}</GhostBtn>
      <PrimaryBtn onClick={onNext} testid="btn-next">{t.next}</PrimaryBtn>
    </div>
  </div>
);

export const Cotation = ({ t, scale, onPrev, onNext }) => (
  <div className="animate-fade-up">
    <h2 className="font-serif-title text-3xl sm:text-4xl text-[var(--gold)] mb-6 text-center">{t.cotTitle}</h2>
    <div className="rounded-3xl bg-[var(--sand)] border border-[var(--border)] p-6 sm:p-8 mb-6">
      <p className="text-[var(--ink)] mb-4">{t.cotText}</p>
      <div className="grid grid-cols-1 sm:grid-cols-5 gap-2">
        {scale.map((s) => (
          <div key={s.value} className="rounded-xl bg-white/70 border border-[var(--border)] p-3 text-center">
            <div className="text-2xl font-serif-title text-[var(--gold)]">{s.value}</div>
            <div className="text-xs text-[var(--ink-soft)] mt-1">{s.label}</div>
          </div>
        ))}
      </div>
    </div>
    <p className="text-sm text-[var(--ink-soft)] mt-6 text-center">{t.cotNote}</p>
    <div className="flex items-center justify-between mt-8">
      <GhostBtn onClick={onPrev} testid="btn-prev">{t.prev}</GhostBtn>
      <PrimaryBtn onClick={onNext} testid="btn-next">{t.beginPassation}</PrimaryBtn>
    </div>
  </div>
);
